import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsModule, ConfigModule } from '@spartacus/core';
import { OutletPosition, provideOutlet } from '@spartacus/storefront';
import { SafePipe } from '../shared/pipe/safe.pipe';
import { CustomCategoriesDetailsComponent } from './custom-categories-details/custom-categories-details.component';
import { CustomContentSearchResultComponent } from './custom-content-search-result/custom-content-search-result.component';
import { CustomMostPopularComponentComponent } from './custom-most-popular-component/custom-most-popular-component.component';
import { CustomOspEmptySearchResultParagraphComponent } from './custom-osp-empty-search-result-paragraph/custom-osp-empty-search-result-paragraph.component';
import { CustomOspSearchResultFooterComponent } from './custom-osp-search-result-footer/custom-osp-search-result-footer.component';
import { CustomOspSearchResultHeaderComponent } from './custom-osp-search-result-header/custom-osp-search-result-header.component';
import { CustomSearchCategoriesComponent } from './custom-search-categories/custom-search-categories.component';

@NgModule({
  declarations: [
    CustomCategoriesDetailsComponent,
    CustomSearchCategoriesComponent,
    CustomOspEmptySearchResultParagraphComponent,
    CustomContentSearchResultComponent,
    SafePipe,
    CustomOspSearchResultHeaderComponent,
    CustomOspSearchResultFooterComponent,
    CustomMostPopularComponentComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    NgbModule,
    FormsModule,
    CmsModule,
    MatProgressSpinnerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ContentItemsComponent: {
          component: CustomCategoriesDetailsComponent,
        },
        OspEmptySearchResultParagraphComponent: {
          component: CustomOspEmptySearchResultParagraphComponent,
        },
        ContentSearchResultComponent: {
          component: CustomContentSearchResultComponent,
        },
      },
    }),
  ],
  providers: [
    provideOutlet({
      id: 'ContentSearchBox',
      position: OutletPosition.REPLACE,
      component: CustomSearchCategoriesComponent,
    }),
    provideOutlet({
      id: 'ContentSearchResult',
      position: OutletPosition.BEFORE,
      component: CustomOspSearchResultHeaderComponent,
    }),
    provideOutlet({
      id: 'ContentSearchResult',
      position: OutletPosition.AFTER,
      component: CustomOspSearchResultFooterComponent,
    }),
  ],
  exports: [CustomCategoriesDetailsComponent, CustomSearchCategoriesComponent],
})
export class OspCategoriesModule {}
